<div id="test-component">
    <h1>Test componnet/route for experimenting</h1>
    @if (testForm$ | async; as testForm) {
        <r1-compass-lib-child-comp [form]="testForm" />
    }

    @if (testForm$ | async; as testFormM) {
        @for (form of testFormM.controls; track form; let i = $index) {
            <form [formGroup]="form">
                <p>Form group #{{ i }}</p>
                <mat-form-field>
                    <mat-label>Type</mat-label>
                    <input matInput type="string" formControlName="type" />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>id</mat-label>
                    <input matInput type="number" formControlName="id" />
                </mat-form-field>
            </form>
        }
    }
</div>
